import React from 'react';
interface PriceSummaryRowProps {
  total: string;
  perUnit: string;
}
export function PriceSummaryRow({
  total,
  perUnit
}: PriceSummaryRowProps) {
  return <div className="flex items-center justify-between py-4" data-id="element-220">
      <span className="text-lg font-bold text-gray-900" data-id="element-221">Total</span>
      <div className="text-right" data-id="element-222">
        <div className="text-2xl font-bold text-gray-900" data-id="element-223">{total}</div>
        <div className="text-sm text-gray-500" data-id="element-224">{perUnit}</div>
      </div>
    </div>;
}